// ============================================================================
// dom.js — az EGYETLEN DOM-elemépítő segéd (2026-10-19, kódaudit: korábban tíz nézetmodul tartott fenn saját, kissé eltérő másolatot,
// és az eltérések valós hibát okoztak: a `disabled: false` egy példányban tiltott gombot adott).
//
//   el("button", { class: "x", text: "Felirat", disabled: false, onclick: kezelo, title: "..." }, [gyerek1, gyerek2])
//
// Szabályok:
//   - null / undefined attribútum-érték: az attribútumot egyáltalán nem állítjuk be (enélkül a setAttribute("disabled", null) a böngészőben
//     "disabled=null" szöveggé alakulna, ami MÉGIS letiltott állapotot jelentene);
//   - text: textContent (nincs HTML-értelmezés: egy szöveg nem tud elemet beinjektálni);
//   - on<esemény>: eseményfigyelő (a név kisbetűsítve: onclick, oninput, onchange...);
//   - disabled / checked: valódi LOGIKAI tulajdonság, csak explicit true (vagy a "true" szöveg: disabled) kapcsolja be;
//   - minden más: attribútum; a gyerekek közül a hamis értékek (null, false) kimaradnak.
// ============================================================================

export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === null || value === undefined) continue;
    if (key === "text") node.textContent = value;
    else if (key.startsWith("on") && typeof value === "function") node.addEventListener(key.slice(2).toLowerCase(), value);
    else if (key === "disabled") node.disabled = value === true || value === "true";
    else if (key === "checked") node.checked = value === true;
    else node.setAttribute(key, value);
  }
  for (const child of children) if (child) node.appendChild(child);
  return node;
}
